import React,{useState, useEffect, useRef}  from 'react';
import { ReactSketchCanvas } from "react-sketch-canvas";
import { useScreenshot } from 'use-react-screenshot'
import {Header,Container, Button,Grid}  from 'semantic-ui-react'
import {useParams} from 'react-router-dom'
import PaketListe from './PaketListe'
import {useApi} from '@wollo-lib/kpe-context'

const styles = {
    border: "0.0625rem solid #9c9c9c",
    borderRadius: "0.25rem",
  };

const Sign=({ws})=>
{
    const {apiSelect}=useApi()
    const [image, takeScreenshot] = useScreenshot()
    const svgRef=useRef()
    const {UID:transaktionUID}=useParams()
    const [pakete,setPakete]=useState([])
    const [kunde,setKunde]=useState({})
    const [transaktion,setTransaktion]=useState({Zuschlaege:[]})


    useEffect(()=>
    {
        const getTransaktion= async()=>
        {
            if(transaktionUID)
            {
                const myPakete=await apiSelect(`/db/TransaktionPakete/${transaktionUID}`,'back')
                const my2Pakete=myPakete.map(paket=>({...paket,Ausliefern:true}))
                setPakete(my2Pakete)
                const [myTransaktion]=await apiSelect(`/db/Transaktion/${transaktionUID}`,'back')
                if(myTransaktion)
                {
                    myTransaktion.Zuschlaege=JSON.parse(myTransaktion.Zuschlaege)
                    setTransaktion(myTransaktion)
                    const [myUser]= await apiSelect(`/db/Kunde/${myTransaktion.Kunde}`,'back')
                    setKunde(myUser)
                }
            }
        
        }
        getTransaktion()

    },[transaktionUID])

    const save= async ()=>
    {
        const svg=await svgRef.current.exportSvg()
        ws.current.send(JSON.stringify({
            __type:'broadcast',
            message: {__type:'signature', signature: svg}
        }   ))
        
        ws.current.send(JSON.stringify({
            __type:'broadcast',
            message: {__type:'close'}
        }   ))
    }

    return(
        <>
            <PaketListe   kunde={kunde} datum={transaktion.Datum} zuschlag={transaktion.Zuschlaege} pakete={pakete}  />
            <div dangerouslySetInnerHTML={{ __html: transaktion.Signature}} />  

        </>
    )
}


export default  Sign
